import { EmailType } from "@models/email-type.model";

export const EmailTypeToDisplayTypeMap: Map<string, 'native' | 'email' | 'attachment'> = new Map<string, 'native' | 'email' | 'attachment'>([
    [ EmailType.Native.value,  'native'],
    [ EmailType.EmailBody.value, 'email'],
    [ EmailType.EmailAttachment.value, 'attachment']
]);